import { createContext, ReactNode, useContext, useMemo, useState } from "react";

/**
 * Vertical space (px) the consent banner occupies at the bottom of the viewport — its height plus
 * its own bottom offset — or null when hidden.
 */
type ConsentBannerInsetContextValue = {
  inset: number | null;
  setInset: (inset: number | null) => void;
};

const noop = () => undefined;

const ConsentBannerInsetContext = createContext<ConsentBannerInsetContextValue>({
  inset: null,
  setInset: noop,
});

export const ConsentBannerInsetProvider = ({ children }: { children: ReactNode }) => {
  const [inset, setInset] = useState<number | null>(null);
  const value = useMemo(() => ({ inset, setInset }), [inset]);

  return (
    <ConsentBannerInsetContext.Provider value={value}>
      {children}
    </ConsentBannerInsetContext.Provider>
  );
};

export const useConsentBannerInset = () => useContext(ConsentBannerInsetContext).inset;

export const useSetConsentBannerInset = () => useContext(ConsentBannerInsetContext).setInset;
